<template>
    <div class="">
        <button
            @click="show()"
            class="btn btn--dark-ad-outline btn--listing-compare tx-14 flex ml-a mb-4 sm:mb-6"
        >
            <!-- <img class="mr-2" width="20px" src="/assets/images/helpers/icon-compare.svg" alt=""> -->
            Simulador
        </button>
        <modal :height="`auto`" :adaptive="true" name="modal-simulator">
            <div
                class="tx-right tx-dark-ad tx-20 pt-2 pr-4"
                style="cursor: pointer;"
            >
                <i @click="hide()" class="far fa-times"></i>
            </div>
            <div class="py-15 px-10 .height-100">
                <table
                    class="table__datasheet tx-14 xl:tx-16 spacing-0 border-collapse w-full"
                >
                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Valor del vehículo
                            </span>
                        </td>
                        <td class="cell w-2/4 tx-right">
                            {{ price | currency }} MXN
                        </td>
                    </tr>
                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Cantidad a financiar
                            </span>
                        </td>
                        <td class="cell w-2/4 tx-right tx-right">
                            {{ financial_mount | currency }} MXN
                        </td>
                    </tr>
                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Enganche
                                <strong>{{ percent_hatch }} %</strong>
                            </span>
                        </td>
                        <td class="cell w-2/4 tx-right">
                            {{ hatch | currency }} MXN
                            <!-- <money
                                class="form-input"
                                v-model="hatch"
                                :readonly="true"
                            ></money> -->
                        </td>
                    </tr>

                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Tasa de interés
                            </span>
                        </td>
                        <td class="cell w-2/4 tx-right">
                            {{ interest_rate }}%
                        </td>
                    </tr>

                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Selecciona un plazo:
                            </span>
                        </td>
                        <td class="cell w-2/4 tx-right">
                            <select
                                class="form-input"
                                v-model="planSelect"
                                @change="selectPlan()"
                            >
                                <option
                                    :value="plan"
                                    v-for="(plan, i) in plans"
                                    :key="i"
                                >
                                    {{ plan }} meses
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr class="row">
                        <td class="heading w-2/4 tx-left">
                            <span>
                                Pago mensual:
                            </span>
                        </td>
                        <td class="cell w-2/ tx-right">
                            $
                            <animated-number
                                class="wizard-price tx-30 md:tx-40 lg:tx-48 weight-300 mb-6 md:mb-10"
                                :value="monthly_payment"
                                :formatValue="formatToPrice"
                                :duration="500"
                            />
                            <small>MXN*</small>
                        </td>
                    </tr>
                </table>
            </div>
        </modal>
    </div>
</template>

<script>
// import AnimatedNumber from "animated-number-vue";
export default {
    props: ["price"],
    // components: {
    //     AnimatedNumber
    // },

    data: () => ({
        percent_hatch: 25,
        plans: [12, 24, 48, 60],
        interest_rate: 10,
        planSelect: null,
        financial_mount: 0,
        monthly_payment: 0,
        hatch: 0
    }),
    methods: {
        show() {
            this.$modal.show("modal-simulator");
        },
        hide() {
            this.$modal.hide("modal-simulator");
            this.monthly_payment = 0;
        },

        selectPlan() {
            const interest = this.interest_rate / 100 / 12;
            this.monthly_payment = (
                (this.financial_mount *
                    (Math.pow(1 + interest, this.planSelect) * interest)) /
                (Math.pow(1 + interest, this.planSelect) - 1)
            ).toFixed(2);
        },

        formatToPrice(price) {
            let val = (price / 1).toFixed(0).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    mounted() {
        this.hatch = (this.price * this.percent_hatch) / 100;
        this.financial_mount = this.price - this.hatch;
    }
};
</script>
